const style = {
  placeholderLoader: {
    height: '20px',
    overflow: 'hidden',
    position: 'relative',
    borderRadius: '4px',

    animation: '$placeholderAnimate 1.7s forwards infinite linear',
    background: 'linear-gradient(to right, #eee 2%, #ddd 18%, #eee 33%)',
    backgroundSize: '1300px',
  },

  '@keyframes placeholderAnimate': {
    '0%': { backgroundPosition: '-650px 0' },
    '100%': { backgroundPosition: '650px 0' },
  },
}

export default style
